import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import Loader from "../components/Loader";
import MatchLayout from "../components/MatchLayout";
import { baseUrl, weeklyMatchesApi } from "../api/api";
import axios from "axios";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import classes from "../css/HomePage.module.css";
import date from "../helpers/date";
import { useSelector } from "react-redux";

const UpcomingPage = () => {
  const [loading, setLoading] = useState(true);
  const [todayMatches, setTodayMatches] = useState([]);
  const [tomorrowMatches, setTomorrowMatches] = useState([]);
  const [upcomingMatches, setUpcomingMatches] = useState([]);

  const { lang } = useSelector((state) => state.langSlice);

  const fetchUpcomingMatches = async (loader) => {
    try {
      if (loader?.loading == true) {
        setLoading(true);
      }
      const res = await axios.get(`${baseUrl}${weeklyMatchesApi}`, {
        timezone: moment.tz.guess(),
      });
      console.log(res.data.response, "response weekly matches");
      if (res?.data?.response?.length > 0) {
        setUpcomingMatches(
          res?.data?.response.filter(
            (match) =>
              date(match?.time)?.date != "Today" &&
              date(match?.time)?.date != "Tomorrow"
          )
        );
        setTodayMatches(
          res?.data?.response.filter(
            (match) => date(match?.time)?.date == "Today"
          )
        );
        setTomorrowMatches(
          res?.data?.response.filter(
            (match) => date(match?.time)?.date == "Tomorrow"
          )
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // toast.error(
      //   error?.data || error?.data?.message || "Something Went Wrong!"
      // );
      // console.log(error, "error");
    }
  };
  useEffect(() => {
    fetchUpcomingMatches({ loading: true });
    const intervalId = setInterval(() => {
      if (!document.hidden) {
        fetchUpcomingMatches({ loading: false });
      }
    }, 15000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Layout active={3}>
      <Drawer active={3} />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={classes.matches_container}>
            <div className={classes.heading_container}>
              <h1 className={classes.heading}>
                {lang == "english"
                  ? "Upcoming Matches"
                  : lang == "spanish"
                  ? "Próximos partidos"
                  : lang == "french"
                  ? "Matchs à venir"
                  : lang == "arabic"
                  ? "المباريات القادمة"
                  : "Upcoming Matches"}
              </h1>
            </div>
            {todayMatches?.map((match, index) => {
              return <MatchLayout match={match} key={index} />;
            })}
            {tomorrowMatches?.map((match, index) => {
              return <MatchLayout match={match} index={index} />;
            })}
            {upcomingMatches?.length > 0 ? (
              upcomingMatches?.map((match, index) => {
                return <MatchLayout match={match} key={index} />;
              })
            ) : (
              <div className={classes.message_box}>
                <p className={classes.message}>
                  {lang == "english"
                    ? "There are no upcoming matches currently in this week.."
                    : lang == "spanish"
                    ? "No hay próximos partidos actualmente en esta semana."
                    : lang == "french"
                    ? "Il n’y a pas de matchs à venir cette semaine."
                    : lang == "arabic"
                    ? "لا توجد مباريات قادمة حاليا في هذا الأسبوع.."
                    : "There are no upcoming matches currently in this week.."}
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </Layout>
  );
};

export default UpcomingPage;
